import axios from 'axios'
import { VueAxios } from './vue-axios'
import { err } from './error'

let apiBaseUrl = '/api'

const service = axios.create({
	baseURL: apiBaseUrl,
	timeout: 300000
})


// request interceptor
service.interceptors.request.use(config => {
	config.headers.Authorization = window.$cookies.get("token");
	return config
}, (error) => {
	return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
	console.log(`%c====================== ${response.config.url} =====> RESPONSE ======================>START`, 'color:green')
	console.log("url ===>", response.config.url)
	console.log("params ===>", JSON.parse(response.config.data))
	console.log("meta ===>", response.data.meta)
	console.log("data ===>", response.data.data)
	console.log(`%c====================== ${response.config.url} =====> RESPONSE ======================>END`, 'color:green')
	return response.data
}, err)

const installer = {
	vm: {},
	install(Vue, router = {}) {
		Vue.use(VueAxios, router, service)
	}
}

export {
	installer as VueAxios,
	service as axios
}
